// ACTIONS
export const WINE_LIST = 'WINE_LIST';
export const WINE_CREATE = 'WINE_CREATE';
export const WINE_READ = 'WINE_READ';
export const WINE_UPDATE = 'WINE_UPDATE';
export const WINE_DELETE = 'WINE_DELETE';
